import { useDecisionMakerProfilePageData } from 'src/app/pages/decisionMakerProfile/pageContext';

type Result = ModelHookResult<{
	endorsements: Array<{
		author: {
			displayName: string | undefined;
			profilePhotoUrl: string | undefined | null;
		};
		message: string | null;
	}>;
}>;

export function useEndorsementQuotes(): Result {
	const {
		data: { enrichedData },
	} = useDecisionMakerProfilePageData();

	const endorsements =
		enrichedData?.endorsements
			?.filter((endorsement) => !!endorsement.rationale)
			.map((endorsement) => ({
				author: endorsement.person
					? {
							displayName: endorsement.person.displayName,
							profilePhotoUrl: endorsement.person.profilePhoto?.photoUrl,
						}
					: {
							displayName: endorsement.organization?.name,
							profilePhotoUrl: endorsement.organization?.profilePhoto?.photoUrl,
						},
				message: endorsement.rationale,
			})) || [];

	return {
		data: {
			endorsements,
		},
	};
}
